import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Center,
  useDisclosure,
} from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import DaumPostcodeEmbed, { Address } from 'react-daum-postcode';

interface PostCodeProps {
  isOpen: boolean;
  callback: (data?: Address) => void;
}

const DaumPostCodeModal = (props: PostCodeProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (props.isOpen) {
      onOpen();
    } else {
      onClose();
    }
  }, [props.isOpen]);

  const handleComplete = (data: Address) => {
    // console.log('address : ', data);

    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    // console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'

    if (props) {
      props.callback(data);
    }
    onClose();
  };

  const onClickClose = () => {
    if (props) {
      props.callback(undefined);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClickClose}>
      <ModalOverlay>
        <ModalContent w="auto" alignSelf={'center'}>
          <ModalHeader fontSize="lg" fontWeight="bold">
            <Box position={'relative'} my="0.5rem" h="1.5rem">
              <Center fontSize={'1.125rem'} fontWeight="semibold">
                주소검색
              </Center>
              <ModalCloseButton
                right={0}
                top={0}
                w={'1.5rem'}
                height={'1.5rem'}
                onClick={onClickClose}
              />
            </Box>
          </ModalHeader>
          <ModalBody p={0}>
            <DaumPostcodeEmbed
              style={{ width: '19.6875rem', height: '29.125rem' }}
              autoClose={false}
              onComplete={handleComplete}
            />
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};

export default DaumPostCodeModal;
